<template>
  <section-layout
    :disabled="!cambiado || loading"
    :loading="loading || saving"
    :showButton="false"
  >
    <template v-slot:title>
      {{localization.tabsTitles.comunicacionProveedor}}
    </template>
    <template v-slot:content>
      <v-row align="center" dense class="mt-3">
        <v-col cols="12">
          <span class="v-label">
            {{localization.email.cuerpoEmail}}
          </span>
          <trumbowyg 
            v-model="configuracion.emailProveedor" 
            id="configuracion.emailProveedor" 
            class="form-control" 
            name="content"
            :disabled="saving"
            @tbw-change="updateCambiado(true)"
            :config = "trumbowygConfig"
          ></trumbowyg>
        </v-col>
        <v-col cols="12">
          {{localization.email.textoInfo.variables}}
          <ul style="list-style-type:disc;">
            <li>{{localization.email.textoInfo.proveedor}}</li>
            <li>{{localization.email.textoInfo.alias}}</li>
            <li>{{localization.email.textoInfo.promocion}}</li>
            <li>{{localization.email.textoInfo.descripcion}}</li>
          </ul>
        </v-col>
      </v-row>
    </template>
  </section-layout>
</template>

<script>
export default {
  props: {
    saving: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    cambiado: {
      type: Boolean,
      default: false
    },
    configuracion: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      trumbowygConfig:{
        btns:[
            ['viewHTML'],
            // ['undo', 'redo'], // Only supported in Blink browsers
            ['formatting'],
            ['bold', 'italic', 'del'],
            ['superscript', 'subscript'],
            ['link'],
            // ['insertImage'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
            ['unorderedList', 'orderedList'],
            ['horizontalRule'],
            ['removeformat'],
            ['fullscreen']
        ],
      },
    }
  },
  computed: {
    localization () {
      return this.$t('sectionConfiguracion')
    }
  },
  methods: {
    updateCambiado (val) {
      // this.cambiado = val
      this.$emit('cambiado', val)
    }
  },
  watch: {
    cambiado (val) {
      // console.log(val)
      this.$emit('cambiado', val)
    }
  }
}
</script>

<style scoped>
.iconSize {
  width: 16px !important;
}
</style>